module.exports = __webpack_public_path__ + "media/10.f723e157.mp3";